import { Model } from "flexlayout-react";
import { VSFPChart } from "../charts/VSFPChart";
import { Legend } from "../charts/Legend";
import { AverageTableView } from "../tableview/AverageTableView";
import { FilterTitle, NoTitle } from "../../vectorset2/layout/VectorSet2Titles";
import { Header } from "../../../components/Header";

import { FilterList } from "../filterlist/FilterList";

export const factory = (node) => {
  var component = node.getComponent();
  switch (component) {
    case "VSFPChart":
      return <VSFPChart />;
    case "AverageTableView":
      return <AverageTableView />;
    case "Legend":
      return <Legend />;
    case "Header":
      return (
        <Header
          title="Please explore the variability of historic forward price performance by V-Score.  Past performance is no guarantee of future results.  See Terms and Conditions and our blog for important additional disclosures."
          label="vsfp"
        >
          <div>History of V-Score Forward Price Performance</div>
        </Header>
      );
    case "ModelDate":
      return <FilterList field={"ModelDate"} search={false} />;
    case "Ticker":
      return <FilterList field={"Ticker"} search={false} />;
    case "Horizon":
      return <FilterList field={"Horizon"} search={false} radio={true} />;
    default:
      return null;
  }
};

export const onRenderTabSet = (tabSetNode, refs) => {
  const typeNode = tabSetNode.getType();
  if (typeNode === "tabset") {
    const children = tabSetNode.getChildren();
    children.forEach((child) => {
      const c = child;
      const comp = c.getComponent();
      const rect = c.getRect();
      if (comp) {
        refs.componentSize.current[comp] = {
          width: rect.width,
          height: rect.height,
        };
      }
    });
  }
};
const getParentTabsets = (model) => {
  const tree = {};
  const walk = (obj) => {
    if (obj.children) {
      const parent = obj.id;
      tree[parent] = [];
      obj.children.forEach((item) => {
        tree[parent].push(item.id);
        walk(item);
      });
    }
  };
  walk(model.layout);
  const parents = {};
  Object.entries(tree).forEach((item) => {
    item[1].forEach((child) => {
      parents[child] = item[0];
    });
  });
  return parents;
};

const modifyModel = (model, layoutState, setLayoutState) => {
  if (layoutState.actionRef.current !== undefined) {
    let tabsetId = "";
    if (layoutState.actionRef.current.isTab) {
      const parent = getParentTabsets(model);
      tabsetId = parent[layoutState.actionRef.current.tabid];
    } else {
      tabsetId = layoutState.actionRef.current.tabid;
    }
    let update = (obj) => {
      if (obj.id === tabsetId) {
        //update
        Object.entries(layoutState.actionRef.current.attributes).forEach(
          (item) => {
            obj[item[0]] = item[1];
          }
        );
      } else if (obj.children) {
        obj.children.forEach((item) => update(item));
      }
    };
    update(model.layout);

    const newState = {
      ...layoutState,
      model: Model.fromJson(model),
    };

    setLayoutState(newState);
    return model;
  } else {
    return model;
  }
};

export const onAction = (action, layoutState) => {
  const nodeID = action.data.fromNode;
  if (nodeID) {
    layoutState.actions.prepareAction(nodeID);
  }
  return action;
};

export const layoutModelChange = (
  model,
  layoutState,
  setLayoutState,
  grefs
) => {
  grefs.layout.current = JSON.stringify(
    modifyModel(model.toJson(), layoutState, setLayoutState)
  );
};
export const onRenderTab = (node, renderState, componentSize) => {
  var component = node.getComponent();
  switch (component) {
    case "ModelDate":
      renderState.content = (
        <FilterTitle
          componentSize={componentSize}
          title={"Model Date"}
          name={component}
        />
      );
      break;
    case "Legend":
      renderState.content = (
        <FilterTitle
          componentSize={componentSize}
          title={"Legend"}
          name={component}
        />
      );
      break;
    case "Horizon":
      renderState.content = (
        <FilterTitle
          componentSize={componentSize}
          title={"Horizon"}
          name={component}
        />
      );
      break;
    case "Ticker":
      renderState.content = (
        <FilterTitle
          componentSize={componentSize}
          title={"Ticker"}
          name={component}
        />
      );
      break;
    case "OaRChart":
      renderState.content = (
        <NoTitle componentSize={componentSize} name={"OaRChart"} />
      );
      break;
    case "VaRChart":
      renderState.content = (
        <NoTitle componentSize={componentSize} name={"VaRChart"} />
      );
      break;
    case "Dummy":
      renderState.content = (
        <NoTitle componentSize={componentSize} name={"Dummy"} />
      );
      break;
    default:
    //do nothing
  }
};
